module.exports = __webpack_public_path__ + "img/Dobroslawa Gogloza.befce9cd.jpg";